"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _material = require("@mui/material");

var _reactTable = require("react-table");

var _Commons = require("./Commons");

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _LayersClear = _interopRequireDefault(require("@mui/icons-material/LayersClear"));

var _Layers = _interopRequireDefault(require("@mui/icons-material/Layers"));

var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip"));

var _FileDownload = _interopRequireDefault(require("@mui/icons-material/FileDownload"));

var _InternalStorageService = require("../InternalStorageService");

var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));

var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));

var _ExpandLess = _interopRequireDefault(require("@mui/icons-material/ExpandLess"));

var _CompareArrows = _interopRequireDefault(require("@mui/icons-material/CompareArrows"));

var _DoDisturbOn = _interopRequireDefault(require("@mui/icons-material/DoDisturbOn"));

var _UnfoldLess = _interopRequireDefault(require("@mui/icons-material/UnfoldLess"));

var _UnfoldMore = _interopRequireDefault(require("@mui/icons-material/UnfoldMore"));

var _reactCsv = require("react-csv");

var _excluded = ["checked"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DefaultMinWidth = 100;
var DefaultWidth = 300;
var DefaultMaxWidth = 1000;

var headerProps = function headerProps(props, _ref) {
  var column = _ref.column;
  return getStyles(props, column.align);
};

var cellProps = function cellProps(props, _ref2) {
  var cell = _ref2.cell;
  return getStyles(props, cell.column.align);
};

var getStyles = function getStyles(props) {
  var align = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left';
  return [props, {
    style: {
      justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
      alignItems: 'center',
      display: 'flex'
    }
  }];
};

var defaultUpdateData = function defaultUpdateData(rowIndex, columnId, value) {
  return console.log(rowIndex, columnId, value);
};

var defaultLabels = {
  virtualized: "\uD83C\uDF00 virtualize",
  hiddenColumn: "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
  hiddenCheckboxToggleAll: "Toggle All",
  sortDesc: ' ⬇',
  sortAsc: ' ⬆',
  noSort: '',
  paginationFirstPage: '|<',
  paginationLastPage: '>|',
  paginationPreviousPage: '<',
  paginationNextPage: '>',
  paginationPage: 'Page',
  paginationSeparator: '|',
  paginationGoToPage: 'Go to page:',
  paginationShow: 'Show'
};
var defaultInitialState = {
  pageSize: 30,
  persistence: false
};

var uniqueIdOrTitle = function uniqueIdOrTitle(uniqueId, title) {
  return uniqueId && uniqueId.length > 0 ? uniqueId : title;
};

var JnpDivTable = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var title = props.title,
      titleIcon = props.titleIcon,
      _props$columns = props.columns,
      columns = _props$columns === void 0 ? [] : _props$columns,
      data = props.data,
      setSelectedRows = props.setSelectedRows,
      _props$selectable = props.selectable,
      selectable = _props$selectable === void 0 ? false : _props$selectable,
      _props$disableSelect = props.disableSelect,
      disableSelect = _props$disableSelect === void 0 ? function () {
    return false;
  } : _props$disableSelect,
      rowOnClick = props.rowOnClick,
      cellOnClick = props.cellOnClick,
      _props$updateData = props.updateData,
      updateData = _props$updateData === void 0 ? defaultUpdateData : _props$updateData,
      _props$labels = props.labels,
      labels = _props$labels === void 0 ? defaultLabels : _props$labels,
      _props$paginationPage = props.paginationPageSizes,
      paginationPageSizes = _props$paginationPage === void 0 ? [10, 20, 30, 40, 50] : _props$paginationPage,
      _props$minColumnWidth = props.minColumnWidth,
      minColumnWidth = _props$minColumnWidth === void 0 ? DefaultMinWidth : _props$minColumnWidth,
      _props$columnWidth = props.columnWidth,
      columnWidth = _props$columnWidth === void 0 ? DefaultWidth : _props$columnWidth,
      _props$maxColumnWidth = props.maxColumnWidth,
      maxColumnWidth = _props$maxColumnWidth === void 0 ? DefaultMaxWidth : _props$maxColumnWidth,
      _props$focusRowId = props.focusRowId,
      focusRowId = _props$focusRowId === void 0 ? null : _props$focusRowId,
      _props$keyPropertyId = props.keyPropertyId,
      keyPropertyId = _props$keyPropertyId === void 0 ? '' : _props$keyPropertyId,
      uniqueId = props.uniqueId,
      _props$initialSelecte = props.initialSelectedRowIds,
      initialSelectedRowIds = _props$initialSelecte === void 0 ? [] : _props$initialSelecte,
      defaultSortColumn = props.defaultSortColumn,
      disableMultipleSelection = props.disableMultipleSelection,
      _props$selectedBackgr = props.selectedBackgroundColor,
      selectedBackgroundColor = _props$selectedBackgr === void 0 ? '#A9D5C5' : _props$selectedBackgr,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$backGroundColo = props.backGroundColor,
      backGroundColor = _props$backGroundColo === void 0 ? " #003061" : _props$backGroundColo,
      _props$initialGroupBy = props.initialGroupBy,
      initialGroupBy = _props$initialGroupBy === void 0 ? [] : _props$initialGroupBy,
      _props$allowGroupBy = props.allowGroupBy,
      allowGroupBy = _props$allowGroupBy === void 0 ? false : _props$allowGroupBy,
      _props$initialAutoRes = props.initialAutoResetExpanded,
      initialAutoResetExpanded = _props$initialAutoRes === void 0 ? true : _props$initialAutoRes,
      _props$customRowProps = props.customRowProps,
      customRowProps = _props$customRowProps === void 0 ? function () {} : _props$customRowProps;

  var allLabels = _objectSpread(_objectSpread({}, defaultLabels), labels);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      columnHiddenAnchorEl = _useState2[0],
      setColumnHiddenAnchorEl = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      exportDataAnchorEl = _useState4[0],
      setExportDataAnchorEl = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedRowId = _useState6[0],
      setSelectedRowId = _useState6[1];

  var _useState7 = (0, _react.useState)((0, _InternalStorageService.getToLocalStorage)(uniqueIdOrTitle(uniqueId, title)) || defaultInitialState),
      _useState8 = _slicedToArray(_useState7, 1),
      savedState = _useState8[0];

  var resolveDefaultSortColumn = function resolveDefaultSortColumn(defaultSortColumn) {
    if (defaultSortColumn) {
      if (_typeof(defaultSortColumn) === 'object' && !Array.isArray(defaultSortColumn)) {
        return [defaultSortColumn];
      }

      return [{
        id: defaultSortColumn,
        desc: false
      }];
    }

    return defaultSortColumn;
  };

  var effectiveDefaultSortColumn = savedState.persistence && savedState.sortBy && savedState.sortBy.length ? savedState.sortBy : resolveDefaultSortColumn(defaultSortColumn);
  var tableRef = (0, _react.useRef)(null);

  var toggleCheckManually = function toggleCheckManually(row, isSelected) {// if (!rowIsUsed(row) && row) {
    //     const effectiveIsSelected = isSelected || !row.isSelected;
    //     row.toggleRowSelected(effectiveIsSelected);
    // }
  };

  var rowIsUsed = function rowIsUsed(row) {
    var _row$original;

    return row === null || row === void 0 ? void 0 : (_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original.isUsed;
  };

  var getSelectedRowId = function getSelectedRowId() {
    return selectedRowId;
  };

  var handleSetSelectedRowId = function handleSetSelectedRowId(id) {
    setSelectedRowId(id);
  };

  var filterTypes = (0, _react.useMemo)(function () {
    return {
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: _Commons.fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: function text(rows, id, filterValue) {
        return rows.filter(function (row) {
          var rowValue = row.values[id];
          return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
        });
      }
    };
  }, []);
  var defaultSortType = (0, _react.useCallback)(function (a, b, accessor) {
    var aValue = a.values[accessor];
    var bValue = b.values[accessor];
    return "".concat(aValue).localeCompare("".concat(bValue), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }, [defaultSortColumn]);
  var defaultColumn = (0, _react.useMemo)(function () {
    return {
      // When using the useFlexLayout:
      minWidth: minColumnWidth,
      // minWidth is only used as a limit for resizing
      width: columnWidth,
      // width is used for both the flex-basis and flex-grow
      maxWidth: maxColumnWidth,
      // maxWidth is only used as a limit for resizing
      sortType: defaultSortType,
      Filter: _Commons.DefaultColumnFilter // Let's set up our default Filter UI

    };
  }, [minColumnWidth, columnWidth, maxColumnWidth, defaultSortColumn]);

  var handleRowOnClick = function handleRowOnClick(e, rowIndex, row) {
    if (rowOnClick) {
      rowOnClick(e, rowIndex, row);
    }

    if (disableMultipleSelection) {
      toggleAllRowsSelected(false);
    }

    toggleCheckManually(row);
  };

  var _useTable = (0, _reactTable.useTable)({
    columns: columns,
    data: data,
    defaultColumn: defaultColumn,
    filterTypes: filterTypes,
    autoResetPagination: true,
    initialState: _objectSpread(_objectSpread(_objectSpread({
      pageSize: 30
    }, savedState.persistence ? savedState : defaultInitialState), effectiveDefaultSortColumn ? {
      sortBy: effectiveDefaultSortColumn
    } : {}), {}, {
      pageIndex: 0,
      selectedRowIds: initialSelectedRowIds,
      groupBy: initialGroupBy,
      autoResetExpanded: initialAutoResetExpanded
    }),
    stateReducer: function stateReducer(newState, action, prevState) {
      switch (action.type) {
        case "switchPersistence":
          var finalState = _objectSpread(_objectSpread({}, newState), {}, {
            persistence: action.payload
          });

          (0, _InternalStorageService.setToLocalStorage)(uniqueIdOrTitle(uniqueId, title), finalState);
          return finalState;

        case "changePage":
          return _objectSpread(_objectSpread({}, newState), {}, {
            pageIndex: action.payload
          });

        default:
          (0, _InternalStorageService.setToLocalStorage)(uniqueIdOrTitle(uniqueId, title), newState);
          return newState;
      }
    },
    // updateData isn't part of the API, but
    // anything we put into these options will
    // automatically be available on the instance.
    // That way we can call this function from our
    // cell renderer!
    updateData: updateData
  }, _reactTable.useFilters, _reactTable.useGroupBy, _reactTable.useSortBy, _reactTable.useExpanded, _reactTable.useResizeColumns, _reactTable.useBlockLayout, _reactTable.usePagination, _reactTable.useRowSelect, function (hooks) {
    hooks.allColumns.push(function (columns) {
      return selectable ? [// Let's make a column for selection
      {
        id: 'selection',
        disableResizing: true,
        minWidth: 35,
        width: 35,
        maxWidth: 35,
        // The header can use the table's getToggleAllPageRowsSelectedProps method
        // to render a checkbox
        Header: function Header(_ref3) {
          var getToggleAllPageRowsSelectedProps = _ref3.getToggleAllPageRowsSelectedProps;
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Commons.IndeterminateCheckbox, _extends({}, getToggleAllPageRowsSelectedProps(), {
            disabled: disableMultipleSelection
          })));
        },
        // The cell can use the individual row's getToggleRowSelectedProps method
        // to the render a checkbox
        Cell: function Cell(_ref4) {
          var row = _ref4.row;

          var _row$getToggleRowSele = row.getToggleRowSelectedProps(),
              checked = _row$getToggleRowSele.checked,
              otherToggleRowSelectedProps = _objectWithoutProperties(_row$getToggleRowSele, _excluded);

          var isChecked = checked && !rowIsUsed(row);
          return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Commons.IndeterminateCheckbox, _extends({}, otherToggleRowSelectedProps, {
            disabled: disableSelect(row),
            checked: isChecked
          })));
        }
      }].concat(_toConsumableArray(columns)) : columns;
    });
    hooks.useInstanceBeforeDimensions.push(function (_ref5) {
      var headerGroups = _ref5.headerGroups;

      if (selectable && headerGroups[0].headers[0]) {
        // fix the parent group of the selection button to not be resizable
        var selectionGroupHeader = headerGroups[0].headers[0];
        selectionGroupHeader.canResize = false;
      }
    });
  }),
      getTableProps = _useTable.getTableProps,
      getTableBodyProps = _useTable.getTableBodyProps,
      headerGroups = _useTable.headerGroups,
      prepareRow = _useTable.prepareRow,
      rows = _useTable.rows,
      expandedRows = _useTable.expandedRows,
      page = _useTable.page,
      canPreviousPage = _useTable.canPreviousPage,
      canNextPage = _useTable.canNextPage,
      pageOptions = _useTable.pageOptions,
      pageCount = _useTable.pageCount,
      gotoPage = _useTable.gotoPage,
      nextPage = _useTable.nextPage,
      previousPage = _useTable.previousPage,
      setPageSize = _useTable.setPageSize,
      getToggleHideAllColumnsProps = _useTable.getToggleHideAllColumnsProps,
      toggleAllRowsSelected = _useTable.toggleAllRowsSelected,
      toggleAllRowsExpanded = _useTable.toggleAllRowsExpanded,
      isAllRowsExpanded = _useTable.isAllRowsExpanded,
      allColumns = _useTable.allColumns,
      selectedFlatRows = _useTable.selectedFlatRows,
      dispatch = _useTable.dispatch,
      _useTable$state = _useTable.state,
      pageIndex = _useTable$state.pageIndex,
      pageSize = _useTable$state.pageSize,
      selectedRowIds = _useTable$state.selectedRowIds,
      persistence = _useTable$state.persistence;

  (0, _react.useEffect)(function () {
    if (rows.length) {
      var rowIdx = rows.findIndex(function (x) {
        return x.original && x.original[keyPropertyId] === focusRowId;
      });
      var row = rows[rowIdx];

      var _page = Math.max(0, Math.floor(rowIdx / pageSize));

      dispatch({
        type: "changePage",
        payload: _page
      });

      if (row) {
        handleSetSelectedRowId(row.id);
        toggleCheckManually(row);
      }
    }
  }, [focusRowId, keyPropertyId]);
  (0, _react.useEffect)(function () {
    if (setSelectedRows) {
      setSelectedRows(selectedFlatRows);
    }
  }, [selectedRowIds]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      clearSelection: function clearSelection() {
        toggleAllRowsSelected(false);
        setSelectedRowId(' ');
      },
      expandAllRows: function expandAllRows() {
        toggleAllRowsExpanded(true);
      }
    };
  });

  var handleColumnHiddenClick = function handleColumnHiddenClick(event) {
    return setColumnHiddenAnchorEl(event.currentTarget);
  };

  var handleColumnHiddenClose = function handleColumnHiddenClose() {
    return setColumnHiddenAnchorEl(null);
  };

  var handlePersistenceState = function handlePersistenceState() {
    return dispatch({
      type: "switchPersistence",
      payload: !persistence
    });
  };

  var columnHiddenOpen = Boolean(columnHiddenAnchorEl);
  var columnHiddenId = columnHiddenOpen ? 'column-hidden' : undefined;

  var handleExportDataClick = function handleExportDataClick(event) {
    return setExportDataAnchorEl(event.currentTarget);
  };

  var handleExportDataClose = function handleExportDataClose() {
    return setExportDataAnchorEl(null);
  };

  var handleCSVLinkData = function handleCSVLinkData(rows) {
    var _rows$;

    var cells = rows === null || rows === void 0 ? void 0 : (_rows$ = rows[0]) === null || _rows$ === void 0 ? void 0 : _rows$.cells;
    return rows.map(function (row) {
      var rowData = columns.reduce(function (acc, cur, i) {
        var _rowInfo$column, _row$original$cur$acc, _row$original2, _row$original3, _rowInfo$column2;

        var rowInfo = cells === null || cells === void 0 ? void 0 : cells.find(function (x) {
          var _x$column;

          return (x === null || x === void 0 ? void 0 : (_x$column = x.column) === null || _x$column === void 0 ? void 0 : _x$column.Header) === cur.Header;
        });
        var csvGetter = rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$column = rowInfo.column) === null || _rowInfo$column === void 0 ? void 0 : _rowInfo$column.csvGetter;
        var cellValue = (_row$original$cur$acc = row === null || row === void 0 ? void 0 : (_row$original2 = row.original) === null || _row$original2 === void 0 ? void 0 : _row$original2[cur === null || cur === void 0 ? void 0 : cur.accessor]) !== null && _row$original$cur$acc !== void 0 ? _row$original$cur$acc : row === null || row === void 0 ? void 0 : (_row$original3 = row.original) === null || _row$original3 === void 0 ? void 0 : _row$original3[cur === null || cur === void 0 ? void 0 : cur.Header];
        var key = rowInfo === null || rowInfo === void 0 ? void 0 : (_rowInfo$column2 = rowInfo.column) === null || _rowInfo$column2 === void 0 ? void 0 : _rowInfo$column2.id;

        if (!!rowInfo && !!csvGetter && typeof csvGetter === 'function') {
          acc[key] = csvGetter(row.original, cellValue);
        } else {
          acc[key] = cellValue;
        }

        return acc;
      }, {});
      return rowData;
    });
  };

  var exportDataOpen = Boolean(exportDataAnchorEl);
  var exportDataId = exportDataOpen ? 'exportdata-popover' : undefined;
  var exportColumnHeadersCSV = columns.map(function (_ref6) {
    var Header = _ref6.Header,
        accessor = _ref6.accessor;
    return {
      label: Header,
      key: accessor
    };
  });
  var effectiveIsAllRowExpanded = isAllRowsExpanded || !rows.some(function (x) {
    return x.isGrouped && !x.isExpanded;
  });
  var isGroupBy = rows.some(function (x) {
    return x.hasOwnProperty('isGrouped');
  });
  var csvLinkData = handleCSVLinkData(rows);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar",
    ref: tableRef,
    style: {
      backgroundColor: backGroundColor
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 3,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }
  }, titleIcon, /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar-title"
  }, title)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 7,
    align: "center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar-results-count"
  }, (0, _Commons.resolveResultsCount)(pageIndex, pageSize, rows.length))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 2,
    align: "right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "toolbar-icons"
  }, isGroupBy ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: effectiveIsAllRowExpanded ? "Collapse all" : "Expand all"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: function onClick() {
      return toggleAllRowsExpanded(!effectiveIsAllRowExpanded);
    }
  }, effectiveIsAllRowExpanded ? /*#__PURE__*/_react.default.createElement(_UnfoldLess.default, null) : /*#__PURE__*/_react.default.createElement(_UnfoldMore.default, null))) : null, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Keep user settings"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handlePersistenceState
  }, persistence ? /*#__PURE__*/_react.default.createElement(_Layers.default, null) : /*#__PURE__*/_react.default.createElement(_LayersClear.default, null))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Hide / Show column"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: "hidden-column",
    onClick: handleColumnHiddenClick
  }, /*#__PURE__*/_react.default.createElement(_Visibility.default, {
    className: "hidden-column-button"
  }))), /*#__PURE__*/_react.default.createElement(_material.Popover, {
    id: columnHiddenId,
    open: columnHiddenOpen,
    anchorEl: columnHiddenAnchorEl,
    onClose: handleColumnHiddenClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    sx: {
      padding: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    sx: {
      py: 0.5
    }
  }, /*#__PURE__*/_react.default.createElement(_Commons.IndeterminateCheckbox, getToggleHideAllColumnsProps()), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    component: "span",
    sx: {
      pl: 1
    }
  }, allLabels.hiddenCheckboxToggleAll)), allColumns.filter(function (column) {
    return column.Header && typeof column.Header === 'string' && column.Header.length;
  }).map(function (column) {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      sx: {
        py: 0.5
      },
      key: column.id
    }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement(_material.Checkbox, _extends({
      size: "small",
      sx: {
        p: 0,
        pb: "1px",
        '&.Mui-checked': {
          color: "#ff562b"
        }
      }
    }, column.getToggleHiddenProps())), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      component: "span",
      sx: {
        pl: 1
      }
    }, column.Header)));
  }))), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: "Export Table data"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    onClick: handleExportDataClick
  }, /*#__PURE__*/_react.default.createElement(_FileDownload.default, {
    className: "hidden-column-button"
  }))), /*#__PURE__*/_react.default.createElement(_material.Popover, {
    id: exportDataId,
    open: exportDataOpen,
    anchorEl: exportDataAnchorEl,
    onClose: handleExportDataClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    sx: {
      padding: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    sx: {
      a: {
        textDecoration: "none",
        color: "unset"
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, {
    id: "export-data-csv",
    data: csvLinkData,
    headers: exportColumnHeadersCSV,
    filename: "".concat(uniqueIdOrTitle(uniqueId, title), "-table_export.csv")
  }, "Export as CSV")))))))), /*#__PURE__*/_react.default.createElement("div", _extends({}, getTableProps(), {
    className: "table"
  }), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
    size: 100
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/_react.default.createElement("div", _extends({}, headerGroup.getHeaderGroupProps(), {
      className: "tr"
    }), headerGroup.headers.map(function (column) {
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, column.getHeaderProps(headerProps), {
        className: "th"
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          height: '28px'
        }
      }, column.canGroupBy && !selectable && allowGroupBy ?
      /*#__PURE__*/
      // If the column can be grouped, let's add a toggle
      _react.default.createElement("div", _extends({}, column.getGroupByToggleProps(), {
        style: {
          height: '28px',
          display: 'flex',
          alignItems: 'center'
        }
      }), column.isGrouped ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        title: 'Cancel group by'
      }, /*#__PURE__*/_react.default.createElement(_DoDisturbOn.default, null)) : /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        title: 'Group by'
      }, /*#__PURE__*/_react.default.createElement(_CompareArrows.default, null))) : null, /*#__PURE__*/_react.default.createElement("div", _extends({}, column.getSortByToggleProps(), {
        style: {
          flexGrow: 1,
          paddingLeft: column.canGroupBy ? 8 : 0
        }
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
        sx: {
          display: "flex",
          alignItems: "center",
          minHeight: "28px"
        }
      }, column.render('Header'), /*#__PURE__*/_react.default.createElement(_material.Grid, {
        component: "span",
        sx: {
          fontSize: "1.2rem",
          fontWeight: "bold",
          pl: '0.3rem'
        }
      }, column.isSorted ? column.isSortedDesc ? allLabels.sortDesc : allLabels.sortAsc : allLabels.noSort))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "searchBox"
      }, column.canFilter ? column.render('Filter') : null)), column.canResize && /*#__PURE__*/_react.default.createElement("div", _extends({}, column.getResizerProps(), {
        className: "resizer ".concat(column.isResizing ? 'isResizing' : '')
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "resizer-separator"
      })));
    }));
  })), /*#__PURE__*/_react.default.createElement("div", _extends({}, getTableBodyProps(), {
    className: "tbody"
  }), page.map(function (row, rowIndex) {
    var _customProps$style;

    prepareRow(row);
    var customProps = row.getRowProps(customRowProps(row));
    var resolvedPropColor = customProps === null || customProps === void 0 ? void 0 : (_customProps$style = customProps.style) === null || _customProps$style === void 0 ? void 0 : _customProps$style.backgroundColor;
    var defaultRowBachgroundColor = resolvedPropColor !== null && resolvedPropColor !== void 0 ? resolvedPropColor : rowIndex % 2 == 0 ? 'white' : '#F8F8F8';
    var backGroundColor = row.id === getSelectedRowId() ? selectedBackgroundColor : defaultRowBachgroundColor;

    var rowProps = _objectSpread(_objectSpread({}, row.getRowProps()), {}, {
      style: _objectSpread(_objectSpread({}, row.getRowProps().style), {}, {
        backgroundColor: backGroundColor
      })
    });

    return /*#__PURE__*/_react.default.createElement("div", _extends({}, rowProps, {
      className: "tr",
      onClick: function onClick(e) {
        return handleRowOnClick(e, rowIndex, row);
      }
    }), row.cells.map(function (cell, cellIndex) {
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, cell.getCellProps(cellProps), {
        className: "td",
        onClick: function onClick(e) {
          if (!selectable || cellIndex !== 0) {
            handleSetSelectedRowId(row.id);
          }

          if (cellOnClick) {
            cellOnClick(e, rowIndex, row, cellIndex, cell);
          }
        }
      }), cell.isGrouped ?
      /*#__PURE__*/
      // If it's a grouped cell, add an expander and row count
      _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", row.getToggleRowExpandedProps(), row.isExpanded ? /*#__PURE__*/_react.default.createElement(_ExpandLess.default, null) : /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)), ' ', cell.render('Cell')) : cell.isPlaceholder ? null : cell.render('Cell', {
        editable: true
      }));
    }));
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-results"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "footer-results-count"
  }, (0, _Commons.resolveResultsCount)(pageIndex, pageSize, rows.length)), /*#__PURE__*/_react.default.createElement("span", {
    className: "footer-select-size"
  }, /*#__PURE__*/_react.default.createElement("select", {
    value: pageSize,
    onChange: function onChange(e) {
      setPageSize(Number(e.target.value));
    }
  }, paginationPageSizes.map(function (pageSize) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: pageSize,
      value: pageSize
    }, "".concat(allLabels.paginationShow, " ").concat(pageSize));
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination-buttons"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return gotoPage(0);
    },
    disabled: !canPreviousPage
  }, allLabels.paginationFirstPage), " ", /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return previousPage();
    },
    disabled: !canPreviousPage
  }, allLabels.paginationPreviousPage), " ", /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination-page-count"
  }, /*#__PURE__*/_react.default.createElement("span", null, "".concat(allLabels.paginationPage, " "), /*#__PURE__*/_react.default.createElement("span", {
    className: "pagination-page-current"
  }, pageIndex + 1), /*#__PURE__*/_react.default.createElement("span", null, "of"), /*#__PURE__*/_react.default.createElement("span", null, pageOptions.length), " ")), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return nextPage();
    },
    disabled: !canNextPage
  }, allLabels.paginationNextPage), " ", /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return gotoPage(pageCount - 1);
    },
    disabled: !canNextPage
  }, allLabels.paginationLastPage), " "))));
});

var _default = JnpDivTable;
exports.default = _default;